export enum ContactForm {
  SEND_CONTACT_FORM_OK = '159019',
  SEND_CONTACT_FORM_KO= '159499',
}

export enum ClientRegister {
  VALID_CERTIFICATE = '158357',
  NOT_REPRESENTATIVE_CERTIFICATE= '159470',
  UNIDENTIFIED_CERTIFICATE= '159471',
  CERTIFICATE_INSTALLED_YES= '159473',
  CERTIFICATE_INSTALLED_NO= '159474',
  CERTIFICATE_INSTALLED_UNCERTAIN= '159475',
  UNIDENTIFIED_CERTIFICATE_CIF_ENTITY= '159476',
  SMS_BLOCKED= '159484',
  CLIENT_AREA_CONTRACT_DOWNLOAD = '158415'
}

export enum PasswordRecovery {
  SMS_BLOCKED = '159493'
}

export enum ProfileOperation {
  ACCESS = '158391',
  DOWNLOAD_CONTRACT_OK = '158393',
  LEGAL_REPRESENTATIVE_DROPOUT = '159503',
  LEGAL_REPRESENTATIVE_INIT = '159505',
  BUSINESS_DATA_DROPOUT = '159508',
  BUSINESS_DATA_INIT = '159509',
  MOBILE_CHANGE_INIT = '158634',
  MOBILE_CHANGE_DROPOUT = '159541',
  MOBILE_CHANGE_BLOCKED = '158635',
  MOBILE_CHANGE_NEW_NUMBER = '158637',
  PASSWORD_CHANGE_INIT = '159083',
  PASSWORD_CHANGE_DROPOUT = '159086',
  PASSWORD_CHANGE_DEFINE_KEY = '159543',
  PASSWORD_CHANGE_KO = '159088'
}

export enum LoginWithCertificateOperation {
  CERTIFICATE_ERROR_WITH_CREDENTIALS = '159457',
  CERTIFICATE_DATA_ERROR = '159458',
  CERTIFICATE_ERROR = '159459',
  VALID_CERTIFICATE = '159460'
}

export enum PatrimonialSinisterOperation {
  MAILBOX_OK = '150177',
  MAILBOX_KO = '159581'
}

export enum BankDataManagementBusinessRO {
  INICIO = '159816',
  CAMBIO_CUENTA_NORMATIVA = '159815',
  ERROR_SERVICIO_CAMBIO_CUENTA = '159814'
}

export enum BankDataManagementBusinessStructure {
  INICIO = 'Cambio CCC: OI. Inicio',
}
